export default __webpack_public_path__ + "static/media/Gotham-Bold.4143ebdb.otf";